import { useEffect, useState } from 'react';

/**
 * The clock as state, re-read every `intervalMs` — so a page left open re-decides
 * anything judged against "now" (a start that has passed, a notice window, a booking
 * that has begun) without waiting for a refetch or a click.
 */
export function useNow(intervalMs: number): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const timer = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(timer);
  }, [intervalMs]);
  return now;
}
